// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.nodata-wrap[data-v-eb3d2222] {\r\n  width: 100%;\r\n  min-height: 200px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\nspan[data-v-eb3d2222] {\r\n    font-size: 12px;\r\n    margin-top: 10px;\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
